import { onboardingShownForScreen, logOnboardingShown } from "../../utils/onboarding";

const screenName = 'onboardingShownCalculator';

const steps = [
    {
        img: '/images/onboarding/onboarding-plan.jpg',
        description: '<span style="font-size: 17px;">Use Calculator by DentiCalc to <b>estimate and discuss prices</b> chairside and avoid confusion about cost.',
        buttons: [
            {
                text: "Let's calculate!",
                class: "primary",
                click: (ctx) => {
                    ctx.currentStep++;
                }
            }
        ],
        skipBtn: "<br/><br/>Note: Don\'t forget to enter your own currency and prices in the settings.",
        mounted: () => {
            logOnboardingShown(screenName);
        }
    }
]

export const onboarding = () => {
    return onboardingShownForScreen(screenName) === 0 ? steps : [];
}
